<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">仪器设备借用申请</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <!-- <el-form-item label="组织结构">
          <el-select v-model="formInline.region" placeholder="请选择组织结构">
            <el-option label="班级一" value="shanghai"></el-option>
            <el-option label="班级二" value="beijing"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1">
          </OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择所属院系" style="width:320px;" @focus="dialogOpen1"
            @clear="handeleClear1" clearable></el-input>
        </el-form-item> -->
        <el-form-item label="设备名称">
          <el-input v-model="formInline.device_name" clearable placeholder="请输入设备名称"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.status" clearable filterable placeholder="请选择状态">
            <el-option v-for="item in $store.state.applyStatus2" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item :label="`所属${$store.state.themeTitle}室`">
          <el-select v-model="formInline.training_room" clearable filterable
            :placeholder="`请选择所属${$store.state.themeTitle}室`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
              :value="item.training_name"></el-option>
          </el-select>
        </el-form-item> -->
        <!--<el-form-item label="日期">
          <el-date-picker v-model="formInline.date" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">借用申请</el-button>
        </el-form-item>
        <!--<el-form-item>
          <el-button type="primary" @click="downloadFile">下载实训设备导入模板</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <Importt :uploadSectionFile="uploadSectionFile"  @refresh="handleQuery" :action="action" :params="params" :btnTitle="btnTitle"></Importt>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :disabled="exportTitle=='导出中...'" @click="handleExportByUrl(formInline)">{{exportTitle}}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleBatchDel">批量删除</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table ref="table" :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column prop="device_name" fixed label="设备名称" min-width="200px">
        </custom-table-column>
        <custom-table-column prop="num" label="借用数量" width="100">
        </custom-table-column>
        <custom-table-column prop="status_desc" label="状态" width="80">
        </custom-table-column>
        <custom-table-column prop="start_time" label="借用时间" width="180">
        </custom-table-column>
        <custom-table-column prop="end_time" label="预计归还时间" width="180">
        </custom-table-column>
        <custom-table-column prop="device.device_model" label="型号" width="160">
        </custom-table-column>
        <custom-table-column prop="device.specification" label="规格" width="160">
        </custom-table-column>
        <custom-table-column prop="usage" label="用途" min-width="200px">
        </custom-table-column>
        <custom-table-column prop="created_at" label="申请时间" width="180">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.row, ['device'])" type="text" size="small">编辑</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
            <el-button @click="handlePrintRow(scope.row)" type="text" size="small">打印</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" title="借用" :visible.sync="centerDialogVisible" width="746px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="借用设备" prop="device_id">
          <el-select v-model="ruleForm.device_id" clearable filterable placeholder="请选择" style="width:552px;" @change="handleEqChange">
            <el-option v-for="(item, index) in $store.state.allEqs" :key="index"
              :label="`${item.device_name}（库存数：${item.device_qty}）`" :value="item.id">
              <p>{{ `${item.device_name}（库存数：${item.device_qty}）` }}</p>
              <p v-if="item.device_model" style=" color: #8492a6; font-size: 13px">型号：{{ item.device_model }}</p>
              <p v-if="item.specification" style=" color: #8492a6; font-size: 13px">规格：{{ item.specification }}</p>
              <!-- <span style="float: left">{{ item.device_name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.id }}</span> -->
            </el-option>
          </el-select>

        </el-form-item>
        <el-form-item label="借用日期" prop="start_time">
          <el-date-picker type="datetime" placeholder="请选择" value-format="yyyy-MM-dd HH:mm:ss"
            v-model="ruleForm.start_time" style="width: 216px;" :picker-options="pickerOptions"></el-date-picker>
        </el-form-item>
        <el-form-item label="预计归还日期" prop="end_time">
          <el-date-picker type="datetime" placeholder="请选择" value-format="yyyy-MM-dd HH:mm:ss"
            v-model="ruleForm.end_time" style="width: 216px;"  :picker-options="pickerOptions"></el-date-picker>
        </el-form-item>
        <el-form-item label="借用数量" prop="num">
          <el-input-number v-model="ruleForm.num" :max="kcnum" placeholder="请输入" style="width:216px;"></el-input-number>
        </el-form-item>
        <el-form-item label="用 途" prop="usage">
          <el-input type="textarea" v-model="ruleForm.usage" placeholder="请输入用途" style="width:552px;"
            :rows="4"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'add'"
            @click="submitFormByFun('ruleForm', createMethod)">确认</el-button>
          <el-button type="primary" v-if="type == 'edit'"
            @click="submitFormByFun('ruleForm', updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
    <div style="display: none;">
      <Printt id="printArea" ref="printt" :printData="printData" ></Printt>
    </div>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinImport } from '@/assets/js/mixin/import';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinValidate } from '@/assets/js/mixin/validate';
import { mixinPrint } from '@/assets/js/mixin/print';

export default {
  name: 'equipmentInto',
  mixins: [mixinList, mixinImport, mixinValidate, mixinOrgan,mixinPrint],
  data() {
    return {
      formInline: {
        device_name: '',
        status: '',
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < (Date.now() - 24*60*60*1000);
        },
      },
      loading: false,
      selectName: '',
      organLabel: '',
      levell: [1, 2],
      total: 40,
      users: [],
      rules: {
        device_id: [{ required: true, message: '请选择', trigger: 'change' }],
        start_time: [{ required: true, message: '请选择', trigger: 'change' }],
        end_time: [{ required: true, message: '请选择', trigger: 'change' }],
        usage: [{ required: true, message: '请输入用途', trigger: 'blur' }],
        num: [
          { required: true, message: '数量不能为空' },
        ],
      },
      ruleForm: { "device_id": "", "num": 0, "start_time": "", "end_time": "", "usage": "" },
      centerDialogVisible: false,
      action: '',
      downloadUrl: 'template/实训设备导入模版.xlsx',
      downloadName: '实训设备导入模版.xlsx',
      btnTitle: '导入实训设备数据',
      exportUrl: '',
      exportBtnTitle: '实训设备列表导出',
      downloadName: '实训设备列表.xlsx',
      kcnum:0
    };
  },
  components: {},
  created() {
    this.action = `${this.baseUrlt}api/device/import`;
    this.exportUrl = `${this.baseUrlt}api/device/devicelistExport`;
  },
  mounted() {
    this.$store.dispatch('getEqs');
    // this.getStudentApply()
    // this.getProvince()
  },
  methods: {
    handleNumbeChange(row) {
      this.numberDialogVisible = true;
      this.ruleForm = {
        device_id: row.id,
        device_no: row.device_no,
        device_name: row.device_name,
        num: '',
        start_time: '',
        end_time: '',
        usage: '',
      }
    },
    async changeBorrowStatus() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let res = await this.$api.instance.interfaceServer(`api/device_borrow/apply/add`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '借用申请成功待审核！',
        });
        this.numberDialogVisible = false;
        // this.handleQuery();
      }
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    async changeDeviceNumber() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let res = await this.$api.update.changeDeviceNumber(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '库存修改成功！',
        });
        this.ruleForm = {
          id: '',
          type: '',
          number: 0,
        };
        this.numberDialogVisible = false;
        this.handleQuery();
      }
    },
    handleEdit(row, filterArr = ['create_at', 'school_id']) {
      this.type = 'edit';
      this.title = '编辑';
      this.ruleForm = this.$until.delProp(row, filterArr);
      this.handleEqChange(row.device_id)
      this.centerDialogVisible = true;
    },
    handleEqChange(val) {
      // this.ruleForm.room_id = e.id
      this.kcnum = parseInt(this.$until.getLabelName(this.$store.state.allEqs, 'id', 'device_qty', val));
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    // handleExport(){
    //   this.$message.info('导出中。。。');
    // },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    async deleteMethod() {
      let res = await this.$api.instance.interfaceServer(`api/new_device/borrow/delete/${this.delid}`, 'DELETE');
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/new_device/borrow/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/new_device/borrow/store', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);
      let res = await this.$api.instance.interfaceServer(`api/new_device/borrow/update/${params.id}`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    handleQuery() {
      this.beforeQuery();
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}

.el-select-dropdown__item {
  height: auto !important;
  line-height: 20px;
  padding: 4px 30px;
}
</style>
